import { render } from "./event.vue?vue&type=template&id=348dd732&scoped=true"
import script from "./event.vue?vue&type=script&lang=js"
export * from "./event.vue?vue&type=script&lang=js"

import "./event.vue?vue&type=style&index=0&id=348dd732&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-348dd732"

export default script